type Props = {
  bayCountyCertificateId?: string;
};

export default function PropertyCompliance({ bayCountyCertificateId }: Props) {
  if (!bayCountyCertificateId) return null;

  return (
    <section className="bg-background-50 border-t border-background-200/60 py-8">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 text-center">
        <p className="text-[11px] md:text-xs uppercase tracking-[0.22em] text-foreground-500">
          Bay County Certificate ID: {bayCountyCertificateId}
        </p>
      </div>
    </section>
  );
}
